import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import List from "./list";

const OrganizationRecommendations = (props) => {
    useEffect(() => {
        return () => props.clearParams("organization-recommendations");
    }, []);

    const { match, location } = props;
    const rootUrl = `${match.path}/list`;

    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => <List {...props} isTable transition="full" title="Все рекомендации" nofilter />}
                />
            </Switch>
        </div>
    );
};

export default OrganizationRecommendations;
